import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../../components/modal/ConfirmDialog";
import { useSqlbaseStore } from "../../stores/sqlbase";
import { useToastStore } from "../../stores/toast";

const UNKNOWN_SIZE_LABEL = "—";

function HandelCacheCard() {
  const { t } = useTranslation();
  const addToast = useToastStore((s) => s.addToast);
  const cacheSize = useSqlbaseStore((s) => s.cacheSize);
  const fetchCacheStats = useSqlbaseStore((s) => s.fetchCacheStats);
  const clearCache = useSqlbaseStore((s) => s.clearCache);

  const [confirming, setConfirming] = useState(false);
  const [clearing, setClearing] = useState(false);

  useEffect(() => {
    fetchCacheStats();
  }, [fetchCacheStats]);

  const handleConfirm = async () => {
    setClearing(true);
    try {
      const { error } = await clearCache();
      if (error) {
        addToast("error", t("settings.sqlbase.cache.clear_failed"));
        return;
      }
      addToast("success", t("settings.sqlbase.cache.cleared"));
    } finally {
      setClearing(false);
      setConfirming(false);
    }
  };

  const sizeLabel = cacheSize ?? UNKNOWN_SIZE_LABEL;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">{t("settings.sqlbase.cache.title")}</h5>
          <p className="text-muted">{t("settings.sqlbase.cache.description")}</p>
          <div className="mb-3">
            <div className="text-muted small">{t("settings.sqlbase.cache.size")}</div>
            <div className="h4">{sizeLabel}</div>
          </div>
          <button type="button" className="btn btn-success" disabled={clearing} onClick={() => setConfirming(true)}>
            {t("settings.sqlbase.cache.clear")}
          </button>
        </div>
      </div>
      {confirming && (
        <ConfirmDialog
          title={t("settings.sqlbase.cache.clear")}
          message={t("settings.sqlbase.cache.confirm")}
          confirmLabel={t("settings.sqlbase.cache.clear")}
          busy={clearing}
          onCancel={() => setConfirming(false)}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
}

export default HandelCacheCard;
